import React, { useState, useEffect, useContext } from "react"
//import { BrowserRouter } from "react-router-dom"
import Cookies from "js-cookie"
import { Toaster } from "react-hot-toast"

import Dashboard from "./pages/dashboard"
import Login from "./pages/login"
import Help from "./pages/help"
import { FE_URL } from "./utils/constants"

import { AuthProvider, AuthContext } from "./utils/authContext"
import { useLocation } from "react-router-dom"

function AppContent() {
  const { authUser, setAuthUser } = useContext(AuthContext)
  const [isLoading, setIsLoading] = useState(true)

  // On mount, read the cookie once and seed our context
  useEffect(() => {
    const raw = Cookies.get("auth")
    if (raw) {
      try {
        const parsed = JSON.parse(raw)
        setAuthUser(parsed)
      } catch (err) {
        console.error("Failed to parse auth cookie:", err)
        setAuthUser(null)
      }
    }
    setIsLoading(false)
  }, [setAuthUser])

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-message">Loading...</div>
      </div>
    )
  }

  if (window.location.pathname === "/help") {
    return (
      <div className="App">
        <Help />
      </div>
    )
  }

  return (
    <div className="App">
      {authUser && authUser.accessToken ? <Dashboard /> : <Login />}
      <Toaster
        position="top-center"
        containerStyle={{
          top: "7px", // stick flush to the top
        }}
      />
    </div>
  )
}

export default function App() {
  /* Temporary link */
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const accessToken = queryParams.get("id")
  const ref = queryParams.get("ref")
  if (accessToken && ref) {
    try {
      const faxNumber = atob(ref)
      const data = {
        accessToken,
        faxNumber,
      }
      Cookies.set("auth", JSON.stringify(data), { expires: 1 }) // Store token for 1 days
    } catch (err) {
      window.location.href = FE_URL
    }
  } else {
    // const raw = Cookies.get("auth")
    // if (typeof raw === "string") {
    //   const parsed = JSON.parse(raw)
    //   if (parsed.faxNumber && parsed.accessToken) {
    //     window.location.href = `https://demowar.loginbridge.net/main.html?ref=${btoa(
    //       parsed.faxNumber
    //     )}&id=${parsed.accessToken}`
    //   } else {
    //     window.location.href = `https://demowar.loginbridge.net`
    //   }
    // } else {
    //   window.location.href = `https://demowar.loginbridge.net`
    // }
  }

  // if (!accessToken) {
  //   return (
  //     <div className="loading-container">
  //       <div className="loading-message">Loading...</div>
  //     </div>
  //   )
  // }

  /* Temporary link */

  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}
